import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router';
import { Grid } from '@material-ui/core';
import UserContext from '../../../../utils/UserContext';
import { isLogin } from '../../../../services/AuthService';
import GraduateManagement from '../GraduateManagement';
import MassMessageManagementGraduate from '../MassMessageManagement/MassMessageManagementGraduate';

import GraduateStateBar from '../../../../components/ManagementState/GraguateStateBar';
import ReportsGraduate from '../ReportsManagement/ReportsGraduate';

import './GeneralGraduateManagement.scss';
import MassMessageScheduled from '../../../../components/MassMessage/MassMessageScheduled';
import { getScheduledMassiveEmail } from '../../../../services/AdminServices';


const GeneralGraduateManagement: React.FC = () => {
  const userContext = React.useContext(UserContext);
  const [selectedSection, setSelectedSection] = useState<string>('');
  const [countScheduled, setCountScheduled] = useState<number>(0);

  const getInitialData = async () => {

    const getInfo: any = await getScheduledMassiveEmail("graduate", true);
    if (getInfo.status === 200) {
      let resultList: number = (await getInfo.json()).count;
      
      setCountScheduled(resultList);
      console.log(resultList)
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    getInitialData();
    const urlPath = window.location.href;
    if (urlPath.includes('/egresados')) {
      setSelectedSection('Gestion');
      userContext.setStateGraduateSection('Gestion');
    } else if (urlPath.includes('mensajeria-egresados')) {
      setSelectedSection('Mensajeria');
      userContext.setStateGraduateSection('Mensajeria');
    } else if (urlPath.includes('reportes-egresados')) {
      setSelectedSection('Reportes');
      userContext.setStateGraduateSection('Reportes');
    } else if (urlPath.includes('mensajeria-programada')) {
      setSelectedSection('Programada');
      userContext.setStateGraduateSection('Programada');
    } else {
      setSelectedSection('Gestion');
      userContext.setStateGraduateSection('Gestion');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.href])

  return (
    <>
      {isLogin() ?
        <>
          <Grid item xs={12} className="state-bar-section">
            <GraduateStateBar selected={selectedSection} countScheduled={countScheduled}/>
          </Grid>
          {selectedSection === "Gestion" &&
            <Grid container item xs={12}>
              <GraduateManagement />
            </Grid>
          }
          {selectedSection === "Mensajeria" &&
            <Grid container item xs={12}>
              <MassMessageManagementGraduate />
            </Grid>
          }
          {selectedSection === "Programada" &&
            <Grid container item xs={12}>
              <MassMessageScheduled />
            </Grid>
          }
          {selectedSection === "Reportes" &&
            <ReportsGraduate />
          }
        </>
        :
        <Redirect to="/" />
      }
    </>
  )
}

export default GeneralGraduateManagement;